import { ComponentConfig } from "@measured/puck";
import CallToAction, { CallToActionProps } from "./CallToAction";
import { iconMapping } from "@foodpilot/foods";
import ColorPickerField, { ColorPickerFieldProps } from "../../fields/ColorPickerField";

export type { CallToActionProps } from "./CallToAction";

const CallToActionConfig: ComponentConfig<CallToActionProps> = {
    label: "Call To Action",
    fields: {
        label: {
            type: "text",
            label: "Label",
        },
        url: {
            type: "text",
            label: "URL",
        },
        target: {
            type: "radio",
            label: "Link Target",
            options: [
                { label: "Same Tab", value: "_self" },
                { label: "New Tab", value: "_blank" },
            ],
        },
        width: {
            type: "select",
            label: "Width",
            options: [
                { label: "Default", value: "" },
                { label: "Auto", value: "auto" },
                { label: "Full", value: "full" },
                { label: "Half", value: "half" },
            ],
        },
        position: {
            type: "radio",
            label: "Position",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ],
        },
        icon: {
            type: "select",
            label: "Icon",
            options: Object.keys(iconMapping).map((key) => ({ label: key, value: key })),
        },
        iconPosition: {
            type: "radio",
            label: "Icon Position",
            options: [
                { label: "Left", value: "left" },
                { label: "Right", value: "right" },
            ],
        },
        textColor: {
            type: "custom",
            render: (props: ColorPickerFieldProps) => <ColorPickerField {...props} />,
            label: "Text Color",
        },
        variant: {
            type: "select",
            label: "Variant",
            options: [
                { label: "Default", value: "" },
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
                { label: "subtitle1", value: "subtitle1" },
                { label: "subtitle2", value: "subtitle2" },
                { label: "body1", value: "body1" },
                { label: "body2", value: "body2" },
                { label: "caption", value: "caption" },
                { label: "overline", value: "overline" },
            ],
        },
    },
    defaultProps: {
        label: "",
        url: "#",
        width: "default",
        position: "left",
        icon: "",
        textColor: "#ffffff",
        variant: "body1",
        iconPosition: "left",
        target: "_blank",
    },
    render: (props: CallToActionProps) => {
        return <CallToAction {...props} />;
    },
};

export default CallToActionConfig;
